module.exports = __webpack_public_path__ + "img/01.ec5d0919.png";